import { useTranslation } from "react-i18next"

const useProvinces = () => {
    const { t } = useTranslation()
    const provincesName = [
        t("Amnat Charoen"),
        t("Ang Thong"),
        t("Bangkok"),
        t("Bueng Kan"),
        t("Buriram"),
        t("Chachoengsao"),
        t("Chai Nat"),
        t("Chaiyaphum"),
        t("Chanthaburi"),
        t("Chiang Mai"), 
        t("Chiang Rai"), 
        t("Chon Buri"), 
        t("Chumphon"),
        t("Kalasin"),
        t("Kamphaeng Phet"),
        t("Kanchanaburi"),
        t("Khon Kaen"),
        t("Krabi"),
        t("Lampang"),
        t("Lamphun"),
        t("Loei"),
        t("Lopburi"),
        t("Mae Hong Son"),
        t("Maha Sarakham"),
        t("Mukdahan"),
        t("Nakhon Nayok"),
        t("Nakhon Pathom"),
        t("Nakhon Phanom"),
        t("Nakhon Ratchasima"),
        t("Nakhon Sawan"),
        t("Nakhon Si Thammarat"),
        t("Nan"),
        t("Narathiwat"),
        t("Nong Bua Lamphu"),
        t("Nong Khai"),
        t("Nonthaburi"),
        t("Pathum Thani"),
        t("Pattani"),
        t("Phang Nga"),
        t("Phatthalung"),
        t("Phayao"),
        t("Phetchabun"),
        t("Phetchaburi"),
        t("Phichit"),
        t("Phitsanulok"),
        t("Phra Nakhon Si Ayutthaya"),
        t("Phrae"),
        t("Phuket"),
        t("Prachinburi"),
        t("Prachuap Khiri Khan"),
        t("Ranong"),
        t("Ratchaburi"),
        t("Rayong"),
        t("Roi Et"),
        t("Sa Kaeo"),
        t("Sakon Nakhon"),
        t("Samut Prakan"), 
        t("Samut Sakhon"), 
        t("Samut Songkhram"), 
        t("Saraburi"),
        t("Satun"),
        t("Sing Buri"),
        t("Sisaket"),
        t("Songkhla"),
        t("Sukhothai"),
        t("Suphan Buri"),
        t("Surat Thani"),
        t("Surin"),
        t("Tak"), 
        t("Trang"),
        t("Trat"), 
        t("Ubon Ratchathani"),
        t("Udon Thani"),
        t("Uthai Thani"),
        t("Uttaradit"),
        t("Yala"),
        t("Yasothon")
    ]
    const provinces = provincesName.map(name => ({
        value: t(name),
        label: t(name)
    }))
    return provinces
}

export default useProvinces